/**
 * Client-side mirror of the API's App\Support\PhoneNumber, so the admin gets
 * immediate feedback instead of a round-trip 422.
 *
 * Canonical format is a bare "62" country code - no "+", no leading "0", no
 * spaces/dashes/parentheses - e.g. "6281234567890". That is what the WhatsApp
 * gateways dial and what the OTP login flows exact-match against, so the
 * backend re-normalizes whatever it receives; sending the canonical form just
 * keeps the two ends in agreement.
 *
 * Keep CANONICAL_PATTERN in sync with the API rule (App\Rules\PhoneNumber).
 */

// "628" + 7-11 more digits (10-14 digits total).
const CANONICAL_PATTERN = /^628[0-9]{7,11}$/;

export function normalizePhoneNumber(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const digits = String(value).replace(/\D+/g, "");

  if (digits === "") {
    return digits;
  }

  if (digits[0] === "0") {
    return "62" + digits.slice(1);
  }

  if (digits.slice(0, 2) === "62") {
    return digits;
  }

  if (digits[0] === "8") {
    return "62" + digits;
  }

  // Unrecognized shape (e.g. a landline code) - leave as-is and let
  // validation reject it rather than guessing.
  return digits;
}

export function isValidPhoneNumber(value) {
  const normalized = normalizePhoneNumber(value);

  return !!normalized && CANONICAL_PATTERN.test(normalized);
}
